import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ConfirmEventType, ConfirmationService, MenuItem, Message } from 'primeng/api';
import { breadcrumb, link, stat } from 'src/app/admin/layout/header/header.component';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { CheckBoxQuestion } from 'src/app/misc/component/dynamic-form/question-checkbox';


@Component({
  selector: 'app-question-bank',
  templateUrl: './question-bank.component.html',
  styleUrl: './question-bank.component.scss'
})
export class QuestionBankComponent {
  skelition = true;
  @Output() updateDataEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;
  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe()
  @Input() tags: any[] = [];
  menuItems: MenuItem[] = [
    {
      label: '<span class="mx-3">تعديل</span>',
      escape: false,
      icon: 'pi pi-refresh',
      command: () => {
        this.actionCall({ id: this.operationType._id, action: 'Update' })
      }
    },
    {
      label: '<span class="mx-3">حذف</span>',
      escape: false,
      icon: 'pi pi-fw pi-trash',
      command: () => {
        this.actionCall({ id: this.operationType._id, action: 'Delete' })
      }
    }
  ];

  updateOnlyMenuItem: MenuItem[] = [
    {
      label: '<span class="mx-3">تعديل</span>',
      escape: false,
      icon: 'pi pi-refresh',
      command: () => {
        this.actionCall({ id: this.operationType._id, action: 'Update' })
      }
    },
  ];

  questions: QuestionBase<string>[] = [];
  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;
  operationType: any;
  openCreateModal: boolean = false;

  allowedTags: string[] = this.permissionService.extractTags('ASSESSMENT_TAGS', 'r')
  @Input() currentQBank: any;
  @Input() questionBanks: any[] = [];
  @Output() assessment: EventEmitter<any> = new EventEmitter<any>();
  standardQBID: string = '65f71c25cf3086b3277d7f2d';
  createdInfo:any;
  openInfoModal: boolean = false;


  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService
  ) { }

  ngOnInit() {
    this.makequestion();
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag)
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange['tags']) {
      this.makequestion();
    }
  }

  changeCurrentQBank(currentQBank: any) {
    this.currentQBank = currentQBank;
    this.assessment.emit(this.currentQBank);
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  openTypeMenu(menu: any, event: any, type: any) {
    this.operationType = type;
    menu.toggle(event);
  }

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: this.translate('Name'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'tag',
        label: this.translate('Tag'),
        required: true,
        options: this.tags.map(e => {
          return { ...e, value: e._id }
        }),
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: "false"
      }),

      new CheckBoxQuestion({
        key: 'standard',
        label: this.translate('Show Standard Question Bank'),
        order: 1,
        className: 'col-md-12 col-sm-12 col-12',
        value: false
      }),
    ];
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;
      data.type = 'QB';
      let res = await this.dataService.postData('question-bank', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error') },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.DynamicFormComponent.resetForm();
      this.updateDataEvent.emit({});
      this.openCreateModal = false;
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      data.type = 'QB';
      let res = await this.dataService.postData(
        `question-bank/${data._id}`,
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      this.updateDataEvent.emit({});
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    console.log($event);
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.operationType;
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: this.translate('Name'),
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),

          new DropdownQuestion({
            key: 'tag',
            label: this.translate('Tag'),
            required: true,
            options: this.tags.map(e => {
              return { ...e, value: e._id }
            }),
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.tag?._id,
            className: 'col-md-12 col-sm-12 col-12',
            visibility:`${this.updateData.tag.tag != 'GENERAL_QB'}`
          }),

          new DropdownQuestion({
            key: 'active',
            label: 'الحالة',
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            order: 4,
            className: 'col-md-12 col-sm-12 col-12',
            value: this.updateData.active,
          })
        ];
        if (this.updateData._id != this.standardQBID) {
          this.updateQuestions.push(new CheckBoxQuestion({
            key: 'standard',
            label: this.translate('Show Standard Question Bank'),
            order: 1,
            className: 'col-md-12 col-sm-12 col-12',
            value: this.updateData.standard
          }))
        }
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  deleteCatagory = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`question-bank/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.updateDataEvent.emit({});
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  hasCreatedBy(type: any) {
    let menuItems: MenuItem[] = [...this.menuItems];
    if (type.createdBy) {
      let info: MenuItem = {
        label: '<span class="mx-3">تم الإنشاء من قبل</span>',
        escape: false,
        icon: 'pi pi-info',
        command: () => {
          this.openInfoModal = true;
          this.createdInfo = type;
        }
      };
      menuItems.push(info);
    }
    return menuItems;
  }

  getName(name: any) {
    if (!!name) {
      return name?.first + " " + name?.middle + " " + name?.last;
    }
    return "-"
  }
}
